/**
 * region for libraries*/
import React, { Fragment, Component } from 'react';
import { TextField, Button, Grid } from '@material-ui/core';
import MessageModal from '../../components/common/MessageModal'
/**
 * region for hepers*/
import ajax from '../../helpers/ajax';
import Constants from '../../constants/Constants';
import typing from '../../helpers/typing';

import { commonFunction } from '../../helpers/commonFunction';

class SynonymsListKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            textSynonyms: "",
            synonyms: [],
            showMessageModal: false
        };
    }

    load() {
        let self = this;
        let requestData = {
            idkeyword: self.props.keyword.IDKEYWORD
        };
        ajax.get(Constants.ROUTE_API_CONTENT_SYNONYMS_BY_KEYWORD,
            {
                requestData: requestData,
                success: function (response) {
                    let stringSynonyms = "";
                    response.data.map((synonym, index) => {
                        stringSynonyms = stringSynonyms + synonym.SYNONYM + "\n";
                        return stringSynonyms;
                    });
                    self.setState({
                        textSynonyms: stringSynonyms,
                        synonyms: response.data
                    });
                }
            });
    }
    componentDidMount() {
        this.load();
    }

    handleChange(event) {
        let self = this;
        let arraySynonyms = event.target.value;
        self.setState({
            textSynonyms: arraySynonyms,
        });
    }

    handleOnCloseMessageModal() {
        this.setState({ showMessageModal: false });
    }

    handleSave(event) {
        let self = this;
        let arraySynonyms = self.state.textSynonyms.split("\n");

        let newArrayOnlyText = [];

        arraySynonyms.forEach(function (item) {
            var temp = commonFunction.replaceNonAdmitedSymbols(item);
            if (!typing.isEmpty(item))
                if (newArrayOnlyText.indexOf(temp) === -1) {
                    newArrayOnlyText.push(commonFunction.replaceNonAdmitedSymbols(item).trim().replaceAll(/\s\s+/g, ' '));
                }
        });

        let requestData = {
            Id: self.props.keyword.IDKEYWORD,
            NameList: newArrayOnlyText
        };
        ajax.post(Constants.ROUTE_API_CONTENT_SYNONYMS_BY_KEYWORD,
            {
                requestData: requestData,
                success: function (response) {
                    let stringSynonyms = "";
                    response.data.map((synonym, index) => {
                        stringSynonyms = stringSynonyms + synonym.SYNONYM + "\n";
                        return stringSynonyms;
                    });

                    let isShowModalError = false
                    if (response.data.length < newArrayOnlyText.length) {
                        isShowModalError = true;
                    }

                    self.setState({
                        textSynonyms: stringSynonyms,
                        synonyms: response.data,
                        showMessageModal: isShowModalError
                    });
                }
            });
    }

    render() {
        let self = this;
        let showMessageModal = self.state.showMessageModal;
        return (
            <Fragment>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            multiline
                            rows="10"
                            fullWidth
                            value={self.state.textSynonyms}
                            onChange={this.handleChange.bind(this)}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            onClick={this.handleSave.bind(this)}
                            color="primary">
                            Save
                        </Button>
                    </Grid>
                </Grid>
                {
                    showMessageModal && (
                        <MessageModal
                            title={"Message"}
                            text={"Not all the synonyms were saved, some of them are duplicated or related to another keyword"}
                            onClose={this.handleOnCloseMessageModal.bind(this)}
                            className="modal-md"
                        />)
                }
            </Fragment>
        );
    }
}
export default SynonymsListKeyword;





